// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2KQTt","range":"MonthRangeSwitch_range__wMXZ_","disabled":"MonthRangeSwitch_disabled__3QCCV"};